import React from 'react';
import cx from 'classnames';

import { Body2, Heading6 } from '../Typography';

import styles from './index.module.scss';

export interface IconListItemProps {
  iconUrl: string;
  title: string;
  text: string;
  className?: string;
}

const IconListItem: React.FC<IconListItemProps> = ({
  iconUrl, // 56x56px (WebP/PNG)
  title,
  text,
  className,
}) => {
  return (
    <li className={cx(styles.wrapper, className)}>
      <img className={styles.image} src={iconUrl} alt={text} />
      <div className={styles.textWrapper}>
        {title && <Heading6>{title}</Heading6>}
        {text && (
          <Body2
            className={cx(styles.text, {
              [styles.textWithoutMargin]: !title,
            })}
          >
            {text}
          </Body2>
        )}
      </div>
    </li>
  );
};

export default IconListItem;
